import {ClaimEnums} from '../enums'

export default {

    getClaimByRouteName(name){
        let pageClaim;
        switch (name) {
            case 'materials':
                pageClaim = ClaimEnums.materialsPage;
                break;
            case 'materialEdit':
            case 'folderEdit':
            case 'questionEdit':
                pageClaim = ClaimEnums.materialCreate;
                break;
            case 'motivation':
                pageClaim = ClaimEnums.motivationPage;
                break;
            case 'news':
            case 'newsEdit':
            case 'newsDetails':
                pageClaim = ClaimEnums.newsPage;
                break;
            case 'projects':
            case 'projectEdit':
            case 'trade-points':
            case 'users':
            case 'userEdit':
            case 'roles':
                pageClaim = ClaimEnums.projectPage;
                break;
            case 'rewardEdit':
            case 'rewardFolderEdit':
                pageClaim = ClaimEnums.rewardsEdit;
                break;
            case 'rating':
                pageClaim = ClaimEnums.ratingPage;
                break;
            case 'reports':
            case 'reportDetails':
                pageClaim = ClaimEnums.reportsPage;
                break;
            case 'spend-bonuses':
                pageClaim = ClaimEnums.spendBonusesPage;
                break;
            case 'analytics':
                pageClaim = ClaimEnums.analyticsPage;
                break;
            case 'sku':
            case 'skuEdit':
            case 'skuDetails':
            case 'skuFolderEdit':
                pageClaim = ClaimEnums.skuPage;
                break;
            case 'cart':
                pageClaim = ClaimEnums.bonusSpend;
                break;
            case 'orders':
                pageClaim = ClaimEnums.ordersPage;
                break;
            case 'sender':
                pageClaim = ClaimEnums.senderPage;
                break;
            case 'faq':
                pageClaim = ClaimEnums.faqPage;
                break;
            case 'tasks':
            case 'tasksTable':
            case 'tasksDetails':
            case 'tasksAnswerEdit':
                pageClaim = ClaimEnums.tasksPage;
                break;
            case 'tasksEdit':
                pageClaim = ClaimEnums.tasksEdit;
                break;
        }
        return pageClaim;
    }

}


// WEBPACK FOOTER //
// ./Content/src/helpers/claimUtils.js